import React from "react";

export const Philosophy = ({size = 20, ...props}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 511.965 511.965"
            {...props}
        >
            <path
                fill="#fd8e59"
                d="M135.982 1.588l-15 171.789 15 164.246 75 15 75-15L308.482 169 285.982.078c-145.31 0-139.659-.597-150 1.51z"
            ></path>
            <path
                fill="#fd5959"
                d="M285.982.078v337.545l75 15 75-15V.078h-150z"
            ></path>
            <path
                fill="#fed843"
                d="M135.982 337.623V1.588c-34.021 6.934-60 37.101-60 73.49v322.545z"
            ></path>
            <path
                fill="#454c95"
                d="M135.982 337.623c-33.137 0-60 26.858-60 60 0 33.139 26.859 60 60 60h150l15-60-15-60h-150z"
            ></path>
            <path
                fill="#353d77"
                d="M405.982 427.623v-15l-15-15 15-15v-15h30v-30h-150v120h150v-30h-30z"
            ></path>
            <path fill="#353d77" d="M150.982 382.623v30h135l15-15-15-15h-135z"></path>
            <path
                fill="#fd5959"
                d="M375.982 511.965l-30-15-30 15v-99.342l30-7.491 30 7.491z"
            ></path>
            <path fill="#262f60" d="M405.982 382.623h-120v30h120v-30z"></path>
            <path
                fill="#cde8ff"
                d="M270.982 244l7.5 15 7.5-15 9.546-15-9.546-15-7.5-15-7.5 15z"
            ></path>
            <path
                fill="#a3dbff"
                d="M300.982 244v-30l-7.5-15-7.5 15v30l7.5 15z"
            ></path>
            <path fill="#e9f4ff" d="M240.982 244v30h45l15-15-15-15h-45z"></path>
            <path
                fill="#cde8ff"
                d="M285.982 274h45v-30h-45zM270.982 93.955V131.5l-15 15 15 7.5v37.5l10 15 5-15 7.5-45-7.5-52.545-7.5-15z"
            ></path>
            <path
                fill="#a3dbff"
                d="M300.982 154l15-7.5-15-15V93.955l-7.5-15-7.5 15V191.5l7.5 15 7.5-15V154z"
            ></path>
            <path fill="#e9f4ff" d="M285.982 63.955h-45v30h45l15-15z"></path>
            <path fill="#cde8ff" d="M330.982 93.955v-30h-45v30z"></path>
            <path
                fill="#e9f4ff"
                d="M255.982 184c-8.271 0-15-6.73-15-15 0-8.271 6.729-15 15-15h15v-30h-15c-24.812 0-45 20.186-45 45 0 24.812 20.187 45 45 45h30l15-15-15-15h-30z"
            ></path>
            <path
                fill="#cde8ff"
                d="M315.982 124h-15v30h15c8.271 0 15 6.729 15 15 0 8.27-6.728 15-15 15h-30v30h30c24.812 0 45-20.187 45-45 0-24.812-20.185-45-45-45z"
            ></path>
        </svg>
    );
}

export default Philosophy;